window. initProductThumbnails = function () {
    var productThumbnails = document.querySelectorAll('.product-shaded-thumbnail');

    const replaceWithFallBack = function (thumbnail) {

        const fallBackImg = thumbnail.getAttribute('data-fallback-img');
        thumbnail.src = fallBackImg;

        const parent = thumbnail.parentElement;
        parent.classList.add('shaded-swatch');

    }

    productThumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('error', () => replaceWithFallBack(thumbnail));
    });
}

document.addEventListener('DOMContentLoaded', function () {
    window.initProductThumbnails();
});